import { Navigate, Outlet } from "react-router-dom";
import { useUserAuth } from "../context/UserContext";
import { isPrivilegedRole } from "../utils/roles";

/**
 * Pages kept for reference and testing only: earlier landing-page drafts, old
 * pricing pages, demos, test pages and admin tools. Admin and tester accounts
 * see them as before; everyone else, signed in or not, lands on the homepage.
 *
 * They are hidden because a visitor would read them as real offers: they show
 * plans, prices, guarantees and legal links that are not (or no longer) what
 * Codenec sells. The code stays in the project so the designs can be reused.
 *
 * This only hides the pages. It does not protect data: anything they call on
 * the backend is checked there (see backend/src/middleware/auth.js).
 */
export function StaffOnlyRoute() {
  const { user } = useUserAuth();
  if (!isPrivilegedRole(user?.role)) return <Navigate to="/" replace />;
  return <Outlet />;
}
